<script>
    import Project from '../js/project';
    import Skill from '../js/project';
    import Button from '../js/button';
    import ProjectDisplay from '../components/project_display.svelte';

    const projects = [
        new Project(
            "Wordoss Website",
            "Business Project",
            "This is the new website for Wordoss, that contains all the privacy policies for the apps. I recycled some code from this website during development, and I made it in a few hours.",
            [
                new Skill("HTML/CSS", 2),
                new Skill("JavaScript", 3),
                new Skill("Svelte", 2),
                new Skill("Git", 2),
                new Skill("VS Code", 3),
            ],
            [
                new Button("Coming soon", 'https://wordoss.com/'),
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fnww.png?alt=media&token=6a6233cc-7786-445f-be36-825f4636f8fc",
            ],
        ),
        new Project(
            "Portfolio Website",
            "Personal Project",
            "This is the website, that you are currently visiting. I took advantage of the situation to try out Svelte. Svelte is awesome!",
            [
                new Skill("HTML/CSS", 2),
                new Skill("JavaScript", 3),
                new Skill("Svelte", 2),
                new Skill("Git", 2),
                new Skill("VS Code", 3),
            ],
            [],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fpo1-min.png?alt=media&token=d37f3e7d-5457-463a-b4b7-702211974436",
            ],
        ),
        new Project(
            "Old Wordoss Website",
            "Personal Business Project",
            "This is the website showcasing the Wordoss app as well as containing the Privacy Policy and EULA.",
            [
                new Skill("HTML/CSS", 2),
                new Skill("JavaScript", 3),
                new Skill("Git", 2),
                new Skill("VS Code", 3),
            ],
            [
                new Button("Check it out", 'https://wordoss.com/'),
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fwo_web1-min.png?alt=media&token=9b3d892c-1d0d-46c4-8c50-e20cdc947c0a",
            ],
        ),
        new Project(
            "Web App Projects",
            "School Project",
            "At school, we had many group projects, where we had to use the Spring Framework to make both simple web apps and REST API’s paired with Front end websites.",
            [
                new Skill("Java", 3),
                new Skill("JavaScript", 3),
                new Skill("HTML/CSS", 2),
                new Skill("Spring", 3),
                new Skill("SQL", 2),
                new Skill("Docker", 2),
                new Skill("Git", 2),
                new Skill("IntelliJ", 4),
                new Skill("VS Code", 3),
                new Skill("Azure", 1),
            ],
            [],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fweb_school_1-min.png?alt=media&token=19e6fdd4-411f-4de2-8815-01d44bc5eee9",
            ],
        ),
    ];
</script>

<section id="projects">
    <div id='container'>
        <div id='container-text'>
            <h1>Web</h1>
            <div style="height: 12px"/>
            <p>Here you can see the web projects, that I've done, along with the tools and technologies, that I used for them. </p>
        </div>
        <div id="carousel">
            {#each projects as project}
                <ProjectDisplay {project} />
            {/each}
        </div>
    </div>
</section>


<style>
    #container {
        padding-left: 32px;
        padding-right: 0px;
        width: 100vw - 32px;
        height: calc(100vh - 80px);
        background-color: #fff;
        display: flex;
        justify-content: start;
        align-items: center;
        border-bottom: 5px solid rgba(0, 0, 0, 0.9);
    }

    #container-text {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #carousel {
        width: 70%;
        display: flex;
        flex-direction: row;
        overflow-x: auto; 
        white-space: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.9);
        margin-top: 24px;
        margin-bottom: 0px;
    }

    p {
        color: rgba(0, 0, 0, 0.6);
        width: 70%;
        text-align: center;
        line-height: 1.3em;
    }

    @media (max-width: 952px) {
        #container {
            display: block;
            flex-direction: column;
            margin: 0px;
            padding: 0%;
            width: 100vw;
            height: auto;
        }
        #container-text {
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 24px;
            margin-top: 48px;
        }
        #carousel {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow-x: auto; 
            white-space: nowrap;
            -ms-overflow-style: none;
            scrollbar-width: none;
            margin-bottom: 48px;
        }
    }

</style>